import { Link, useLocation } from "react-router-dom";
import { Home, MapPin, Sparkles, Users, MoreHorizontal } from "lucide-react";

const navLinks = [
  { to: "/", label: "Home", icon: Home },
  { to: "/places", label: "Places", icon: MapPin },
  { to: "/trip-ai", label: "Trip AI", icon: Sparkles },
  { to: "/channels", label: "Feeds", icon: Users },
  { to: "/profile", label: "More", icon: MoreHorizontal },
];

export default function DesktopLayout({ children }) {
  const { pathname } = useLocation();

  const isActive = (to) => {
    if (to === "/") return pathname === "/";
    return pathname.startsWith(to);
  };

  return (
    <div className="flex min-h-[calc(100vh-64px)] w-full">
      {/* Sidebar - hidden on mobile, fixed 240px on desktop */}
      <aside className="hidden md:flex flex-col w-[240px] fixed top-[64px] bottom-0 border-r border-gray-200 bg-white p-4 overflow-y-auto z-40">
        <nav className="flex flex-col gap-2 mt-4">
          {navLinks.map((link) => {
            const Icon = link.icon;
            const active = isActive(link.to);
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-colors ${
                  active
                    ? "bg-[#1a3a1a]/10 text-[#1a3a1a] font-semibold"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                <Icon size={20} className={active ? "text-[#1a3a1a]" : "text-gray-500"} />
                {link.label}
              </Link>
            );
          })}
        </nav>
      </aside>

      {/* Main Content Area */}
      <main className="flex-1 w-full md:ml-[240px] md:max-w-[800px] md:mx-auto pb-20 md:pb-0">
        {children}
      </main>
    </div>
  );
}
